module.exports = __webpack_public_path__ + "static/media/YF55_6.93053743.jpg";